<script lang="ts">
  import { Image } from "sveltestrap";
  import data from "../../../../Data/Chat/Chat.json";
  import ProfileTabContent from "./ProfileTabContent.svelte";
  import ContactTabContent from "./ContactTabContent.svelte";
  let imgPath: string = "/assets/images/user";
  export let getId: string;
</script>

<div class="tab-content" id="info-tabContent">
  <div
    class="tab-pane fade {getId === 'info-home-tab' ? 'show active' : ''}"
    id="info-home-tab"
  >
    <div class="people-list">
      <ul class="list">
        {#each data.calldata as chatItem}
          <li class="clearfix">
            <Image
              class="rounded-circle user-image"
              src="{imgPath}/{chatItem.img}"
              alt=""
            />
            <div class="about">
              <div class="name">{chatItem.name}</div>
              <div class="status">
                <i class="fa fa-{chatItem.icon} font-{chatItem.color}" />{chatItem.time}
              </div>
            </div>
          </li>
        {/each}
      </ul>
    </div>
  </div>
  <ProfileTabContent {getId} />
  <ContactTabContent {getId} />
</div>
